import type {
  IAnalyticsProvider,
  IAuthProvider,
  IDataProvider,
  IPurchaseProvider,
  IRemoteConfigProvider,
} from '@puzzlemania/core';
import {
  MockAnalyticsProvider,
  MockAuthProvider,
  MockDataProvider,
  MockPurchaseProvider,
  MockRemoteConfigProvider,
} from '@puzzlemania/providers-mock';

/** The raw, frozen-interface providers every platform service is built on top of. */
export interface PlatformServices {
  auth: IAuthProvider;
  data: IDataProvider;
  remoteConfig: IRemoteConfigProvider;
  analytics: IAnalyticsProvider;
  purchase: IPurchaseProvider;
}

/**
 * Constructs the Mock* providers exactly once per app load — always, regardless of
 * DEV/PROD. Used directly for DEV boots and as PlatformServicesContext's synchronous
 * test-only fallback (composeServicesSync()). The real non-DEV boot path resolves the
 * real Supabase-backed providers in resolvePlatformServices.ts instead of here, because
 * their construction can require awaiting and this function must stay synchronous for
 * the fallback.
 */
export function createPlatformServices(
  overrides: Partial<PlatformServices> = {},
): PlatformServices {
  return {
    auth: overrides.auth ?? new MockAuthProvider(),
    data: overrides.data ?? new MockDataProvider(),
    remoteConfig: overrides.remoteConfig ?? new MockRemoteConfigProvider(),
    analytics: overrides.analytics ?? new MockAnalyticsProvider(),
    purchase: overrides.purchase ?? new MockPurchaseProvider(),
  };
}
